import { useState } from "react";
import { toast } from "react-toastify";
import { RxPerson } from "react-icons/rx";
import { useNavigate } from "react-router-dom";

import Grid from "@Components/Grid";
import Button from "@Components/Button";
import TextField from "@Components/Inputs/TextField";

import styles from "./Auth.module.scss";
import { usePasswordReset } from "@Hooks/usePasswordReset";

interface Credentials {
  email: string;
}

function ForgotPassword() {
  const [credentials, setCredentials] = useState<Credentials>({
    email: "",
  });
  const navigate = useNavigate();
  const successCallback = () => {
    toast.info(
      "Password reset link sent! Please, check your email to complete the update password process.",
      {
        position: "top-center",
      }
    );
    navigate("/sign-in");
  };
  const { sendPasswordResetEmail } = usePasswordReset(successCallback);
  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (credentials.email) {
      sendPasswordResetEmail({ email: credentials.email });
    } else {
      toast.error("Enter valid email!");
    }
  }

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
      <Grid
        container
        rowSpacing={1}
        alignItems="center"
        direction="column"
        style={{ maxWidth: "485px", margin: "auto" }}
      >
        <Grid xs={12}>
          <h1
            style={{
              textAlign: "center",
              fontSize: "38px",
              color: "#29282E",
              fontWeight: "700",
            }}
          >
            Reset your password
          </h1>
        </Grid>
        <Grid xs={12}>
          <TextField
            onChange={(e) => {
              setCredentials((x) => ({
                ...x,
                email: e.target.value,
              }));
            }}
            labelStyle={styles.labelStyle}
            className={`${styles.authInput} ${styles.inputBorder}`}
            placeholder="Email"
            value={credentials.email ?? ""}
            name="email"
            startIcon={<RxPerson />}
            type="text"
          />
        </Grid>
        <Grid xs={12}>
          <Button
            variant="blue"
            className={styles.authButton}
            type="submit"
            style={{ fontSize: "30px", marginTop: "10px" }}
          >
            Reset password
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default ForgotPassword;
